import { Link } from 'react-router-dom';
import { Icon } from './ui/Icon';
import { linkButtonClasses } from './ui/buttonStyles';

/**
 * Shown next to a full building, science or ship-upgrade queue when a higher
 * premium tier would add slots — takes the player to the premium page.
 */
export function UnlockSlotsButton() {
    return (
        <Link to="/premium" className={linkButtonClasses('ghost')} data-testid="unlock-more-slots">
            <Icon name="lock" size={14} />
            Unlock more slots
        </Link>
    );
}

export default UnlockSlotsButton;
